import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { resetFilters } from "../../slices/filters";
export const useResetFilters = () => {
    const dispatch = useDispatch();
    return useCallback(() => {
        dispatch(resetFilters());
    }, [dispatch]);
};
